import { Word } from "../grammar/Word";
import { adverb } from "../grammar/WordCreators";
import { Keyword } from "../course/Keyword";

export const dictionaryI: Word[] = [
  adverb({ dk: "i aften", en: "tonight" }, 2, [Keyword.TIME]),
  adverb({ dk: "i dag", en: "today" }, 2, [Keyword.TIME]),
  adverb({ dk: "i morgen", en: "tomorrow" }, 2, [Keyword.TIME]),
  adverb({ dk: "i øjeblikket", en: "currently" }, 2, [Keyword.TIME]),
];